import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AppPage from 'view/AppPage';
import LoginPage from 'view/LoginPage';
import { ForgotPasswordPage } from 'view/ForgotPasswordPage';
import { SmsCodePage } from 'view/SmsCodePage';
import { ChangePasswordPage } from 'view/ChangePasswordPage';
import { SuccessPage } from 'view/SuccessPage';
import { DeviceVerifyWarningPage } from 'view/DeviceVerifyWarningPage';
import { DeviceVerifyPage } from 'view/DeviceVerifyPage';
import { Provider } from 'react-redux';
import { store } from './store';
import './App.less';
import PrivateRoute from './utils/PrivateRoute';
import { AuthLayout } from './components/layout/AuthLayout/AuthLayout';

const StoreProvider = Provider as React.ComponentType<{ store: typeof store; children: React.ReactNode }>;

const App: React.FC = () => (
  <StoreProvider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PrivateRoute/>}>
          <Route path="/" element={<AppPage/>}/>
        </Route>
        <Route
          path="/login"
          element={<LoginPage/>}
        />

        <Route element={<AuthLayout />}>
          <Route
            path="/forgot/:type"
            element={<ForgotPasswordPage/>}
          />
          <Route
            path="/sms-code/:type"
            element={<SmsCodePage/>}
          />
          <Route
            path="/change-password"
            element={<ChangePasswordPage/>}
          />
          <Route
            path="/success"
            element={<SuccessPage/>}
          />
          <Route
            path="/verify-device-warning"
            element={<DeviceVerifyWarningPage/>}
          />
          <Route
            path="/verify-device"
            element={<DeviceVerifyPage/>}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  </StoreProvider>
);

export default App;
